module.exports = __webpack_public_path__ + "img/lit_monthly.e3a09e95.png";